import CalendarPage from './CalendarPage';
import EditEventModal from './EditEventModal';
import EventDiscussionHero from './EventDiscussionHero';
import InterestedList from './InterestedList';

export const components = {
  CalendarPage,
  EditEventModal,
  EventDiscussionHero,
  InterestedList,
};
